export const getCardById = (state, id) => {
  return state?.cards?.byId[id] || false;
};

export const getUserFavoritedCards = (state, limit = 20) => {
  if (!limit) {
    return state?.user?.favorites.map((id) => state?.cards?.byId[id]).filter(Boolean);
  }

  const favoriteIds = state?.user?.favorites?.slice(0, limit) || [];
  return favoriteIds.map((id) => state?.cards?.byId[id]).filter(Boolean);
};

export const getUserRecentlyViewedCards = (state, limit = 20) => {
  if (!limit) {
    return state?.user?.recentlyViewedCards.map((id) => state?.cards?.byId[id]).filter(Boolean);
  }
  const recentIds = state?.user?.recentlyViewedCards?.slice(0, limit) || [];
  return recentIds.map((id) => state?.cards?.byId[id]).filter(Boolean);
};

export const getAllCards = (state, limit = 8) => {
  if (!limit) {
    return state?.cards?.allIds?.map((id) => state?.cards?.byId[id]);
  }
  return state?.cards?.allIds.slice(0, limit)?.map((id) => state?.cards?.byId[id]);
};

export const getCuratedCollections = (state) => {
  const collectionIds = state.cards.curatedCollections.allIds || [];
  return collectionIds.map((id) => state.cards.curatedCollections.byId[id]);
};

export const getCuratedCollectionsWithCardDetails = (state) => {
  const collectionIds = state.cards.curatedCollections.allIds || [];
  return collectionIds.map((id) => {
    const collection = state.cards.curatedCollections.byId[id];
    const fullCards = (collection?.cards || []).map((cardId) => state.cards.byId[cardId]);
    return {
      ...collection,
      cards: fullCards,
    };
  });
};

export const getUserFavoritedCuratedCollections = (state) => {
  const favoriteIds = state.user.favoriteCuratedCollections || [];
  return favoriteIds.map((id) => state.cards.curatedCollections.byId[id]);
};
